export default "__VITE_ASSET__Chy4BIbK__"